import React, { Component } from "react";
import _ from 'i18n';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend, ResponsiveContainer
} from "recharts";
import {CommonLoader} from "../../../common/CommonLoader";
import {formatAmount} from "../../../../services/utils";
import RegistrationCAFilter from "../../../Filters/EventStats/EventRegistrantLinechart/RegistrationCAFilter";
import { connect } from "react-redux";

@connect(store => ({
  auth: store.auth
}))
class EventLineChart extends Component {

  translateData = (preparedData) => {
    const {language} = this.props;
    if(language != 'fr'){
      preparedData.forEach(element => {
        element.name = _(element.name);
      })
    }
    return preparedData;
  }

  prepareData = () => {
    const {data, type} = this.props;
    let copiedData = data.map(element => Object.assign({}, element));
     let preparedData = copiedData.map(element => {
      element[_('CONGRESS')] = type === 'CA' ? (element.congrès / 100) : element.congrès;
      element[_('TRAININGS')] =  type === 'CA' ? (element.formations / 100) : element.formations;
      element[_('CYCLES')] =  type === 'CA' ? (element.cycles / 100) : element.cycles;
      element[_('CYCLES_ESSENTIAL')] =  type === 'CA' ? (element.cycles_essential / 100) : element.cycles_essential;
      element[_('SEASONS')] =  type === 'CA' ? (element.saisons / 100) : element.saisons ;
      element[_('MONTHLY_PREMIUM')] =  type === 'CA' ? (element.monthly_premium / 100) : element.monthly_premium ;
      element[_('YEARLY_PREMIUM')] =  type === 'CA' ? (element.yearly_premium / 100) : element.yearly_premium ;
      element['total'] = element[_('CONGRESS')] + element[_('TRAININGS')] + element[_('CYCLES')] +  element[_('CYCLES_ESSENTIAL')] + element[_('SEASONS')] + element[_('MONTHLY_PREMIUM')] + element[_('YEARLY_PREMIUM')];            
      // element.premium =  type === 'CA' ? element.premium/100 : element.premium ;
      return element;
    })
    
    return this.translateData(preparedData);
  }

  getCurrentYearMonth() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}`;
  }
  
  render() {
    const {data, chartLinesToShow, fetching, type, updateChartType, frequency, eventStatsFilter, period} = this.props;    
    
    const prepareData = this.prepareData();
    const transformedPrepareData = [];
    
    const currentMonth = new Date().getMonth();
    const currenDay = new Date().getDate();

    if(eventStatsFilter.year.length == 1 && eventStatsFilter.year[0] == new Date().getFullYear()){
      if(frequency == 'MONTHLY'){
        for (let index = 0; index <= currentMonth; index++) {
          transformedPrepareData.push(prepareData[index]);
        }
      } else if (frequency == 'DAILY' && period.length > 0 && period[0] == this.getCurrentYearMonth()) {
        for (let index = 0; index < currenDay; index++) {
          transformedPrepareData.push(prepareData[index]);
        }
      } else {
        prepareData.forEach(element => {
          transformedPrepareData.push(element);
        });
      }
    } else {
      prepareData.forEach(element => {
        transformedPrepareData.push(element);
      });
    }
    
    
    return (
      <React.Fragment>
      <div style={{width: '100%'}}>
            <RegistrationCAFilter type={type} updateType={updateChartType}/>
      </div>
      <div>
        {
          fetching === true ?
            <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"}/> :
            (
              data.length === 0 ?
                <div className={'flex items-center flex-column justify-center'} style={{minHeight : '300px'}}>
                  <div className={'chart-registrant-number-label mb-3'} style={{textTransform : 'none'}}>{type === 'REGISTRATION' ? _('NO_REGISTRATIONS') : _('NO_CA')}</div>
                </div>
                :
                <ResponsiveContainer width={'100%'} height={300}>
                  <LineChart
                    data={transformedPrepareData}
                    margin={{
                      top: 10,
                      right: 30,
                    }}
                    style={{
                      fontSize: '12px',
                      fontFamily: 'Roboto',
                      fontStyle: 'normal',
                      fontWeight: 400
                    }}
                  >
                    <CartesianGrid stroke="#D8DDE2" vertical={false}
                                   strokeDasharray="4"/>
                    <XAxis dataKey="name" tickMargin={10} axisLine={false}
                           tickLine={false} tick={{fill: '#6D7F92'}}/>
                    <YAxis tickMargin={10} axisLine={false} tickLine={false}
                           tick={{fill: '#6D7F92'}} allowDecimals={false}/>
                    <Tooltip contentStyle={{'borderRadius' : '5px'}} itemStyle={{textTransform : "capitalize"}}
                             formatter={type === 'CA' ? (value) => formatAmount(value, false) : (value) => value}
                    />

                    {
                      chartLinesToShow.includes('formations') &&
                      <Line
                        dataKey={_('TRAININGS')}
                        stroke="#18A0FB"
                        activeDot={{r: 8}}
                        type='linear'
                        dot={{stroke: '#18A0FB', strokeWidth: 6}}
                      />
                    }
                    {
                      chartLinesToShow.includes('cycles') &&
                      <Line
                        dataKey={_('CYCLES')}
                        stroke="#5F5DE8"
                        activeDot={{r: 8}}
                        type='linear'
                        dot={{stroke: '#5F5DE8', strokeWidth: 6}}
                      />
                    }
                    {
                      chartLinesToShow.includes('cycles_essential') &&
                      <Line
                        dataKey={_('CYCLES_ESSENTIAL')}
                        stroke="#14B7AD"
                        activeDot={{r: 8}}
                        type='linear'
                        dot={{stroke: '#14B7AD', strokeWidth: 6}}
                      />
                    }
                    {
                      chartLinesToShow.includes('saisons') &&
                      <Line
                        dataKey={_('SEASONS')}
                        stroke="#F47F4D"
                        activeDot={{r: 8}}
                        type='linear'
                        dot={{stroke: '#F47F4D', strokeWidth: 6}}
                      />
                    }
                    {/* {
                      chartLinesToShow.includes('premium') &&
                      <Line
                        dataKey="premium"
                        stroke="#FB1E5B"
                        activeDot={{r: 8}}
                        type='linear'
                        dot={{stroke: '#FB1E5B', strokeWidth: 6}}
                      />
                    } */}
                    {
                      chartLinesToShow.includes('monthly_premium') &&
                      <Line
                        dataKey={_('MONTHLY_PREMIUM')}
                        stroke="#FB1E5B"
                        activeDot={{r: 8}}
                        type='linear'
                        dot={{stroke: '#FB1E5B', strokeWidth: 6}}
                      />
                    }
                    {
                      chartLinesToShow.includes('yearly_premium') &&
                      <Line
                        dataKey={_('YEARLY_PREMIUM')}
                        stroke="#FFD433"
                        activeDot={{r: 8}}
                        type='linear'
                        dot={{stroke: '#FFD433', strokeWidth: 6}}
                      />
                    }
                    {
                      chartLinesToShow.includes('congrès') &&
                      <Line
                        dataKey={_('CONGRESS')}
                        stroke="#6D7F92"
                        activeDot={{r: 8}}
                        type='linear'
                        dot={{stroke: '#6D7F92', strokeWidth: 6}}
                      />
                    }

                    <Line
                        dataKey={'total'}
                        stroke="#000"
                        activeDot={{r: 8}}
                        type='linear'
                        dot={{stroke: '#000', strokeWidth: 6}}
                     />
                  </LineChart>
                </ResponsiveContainer>
            )

        }
      </div>
    </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

export default connect(mapStateToProps)(EventLineChart);







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChart.js